function useList() {
  const renderLack = ({ quantity, scanned }) => {
    if (scanned) {
      return quantity - scanned;
    } else {
      return quantity || 0;
    }
  };

  return { renderLack };
}

export default useList;
